import { Component, WritableSignal, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'
import { TagModule } from 'primeng/tag'
import { TooltipModule } from 'primeng/tooltip'

import { FlxTableDateFormatPipe } from '../../../../pipes/flx-date.pipe'

@Component({
  imports: [TooltipModule, TagModule, FlxTableDateFormatPipe],
  template: ` <div
    [innerHTML]="dateStarted() | flxTableDateFormat: true : false : true"
    [attr.data-testId]="testId()"
    class="table-date"
  ></div>`,
})
export class FlxDateCellComponent implements ICellRendererAngularComp {
  dateStarted: WritableSignal<string> = signal<string>(null)
  testId = signal<string | null>('')

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.dateStarted.set(params.value)
    this.testId.set(`table-cell-${params.column.getColId()}`)
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    this.dateStarted.set(params.value)
    this.testId.set(`table-cell-${params.column.getColId()}`)
    return true
  }
}
